/*common*/
require('./common');

/*custom css files*/
require('../scss/pages/home/layout.scss');

/*custom js files*/
require('../js/partials/parallax');



// WEBPACK FOOTER //
// ./src/home.js